interface JobPercentageProgressProps {
  stage: string;
  percentage: number | null;
}

/** Shared legacy fallback for the dashboard and job modal. Zero is measured progress. */
export default function JobPercentageProgress({ stage, percentage }: JobPercentageProgressProps) {
  return (
    <div>
      <div className="flex flex-wrap justify-between gap-2 text-sm text-text-secondary dark:text-text-dark-secondary mb-1">
        <span>{stage}</span>
        <span>{percentage === null ? 'Progress unknown' : `${Math.round(percentage)}%`}</span>
      </div>
      {percentage !== null && <progress aria-label="Job progress" value={percentage} max={100} className="w-full h-2 appearance-none overflow-hidden rounded-full accent-primary-700 [&::-webkit-progress-value]:bg-primary-700 [&::-webkit-progress-bar]:bg-background-tertiary dark:[&::-webkit-progress-bar]:bg-background-dark-tertiary [&::-moz-progress-bar]:bg-primary-700" />}
    </div>
  );
}
